<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.chart.list')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm/chart">
              <span>{{$t('tlt.chart.list')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button class="btn btn-outline-primary" v-on:click="MMFNew('chart')">
            <i class="fa fa-fw fa-lg fa-plus"></i>
            <span class="text">{{ $t("btn.basic.add") }}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.chart.name")}}</label>
                 <input
                  class="form-control"
                  type="text"
                  v-model="nameFilter"
                />
                </div>
                
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.chart.description")}}</label>
                 <input
                  class="form-control"
                  type="text"
                  v-model="descriptionFilter"
                />
                </div>

                  <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                     <button class="btn btn-outline-secondary mr-1" type="button"
                                         v-on:click="MMFClearFilter('chart')">
                          <i class="fa fa-fw fa-lg fa-eraser"></i>
                          <span class="text">{{ $t("btn.basic.clear") }}</span>
                      </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('chart')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

       <div id="qualityItemResultTable" class="content">
        <div class="card my-1">
          
           <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component">
              </div>
              <mmf-table entity="chart" inline-actions-disabled :singleChoice='true'>
                </mmf-table>
            </div>
          </div>
        </div>
      </div>

    </section>
   
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields,gridFields } from "@/model/adm/Chart";
import MmfTable from "@/components/MmfTable";


// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "chart/getField",
  mutationType: "chart/updateField"
});

export default {
  name: "chartList",
  data() {
    return {
     
    };
  },
  components: { MmfTable },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
   
    ...mapFields(filterFields),
  
    ...mapState({
      rows: state => state.chart.rows,
      tableColumns: gridFields,
      entity: state => state.chart.entity,  
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows","MMFClearFilter","MMFNew" ]),
    
   
  },

   
};
</script>
